import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const FilterChips = ({
  hasActiveFilters,
  sortedScopes,
  scopes,
  filters,
  budgetWarningOptions,
  toggleStatusFilter,
  toggleBudgetWarningFilter,
  setFilters,
  clearAllFilters
}) => {
  if (!hasActiveFilters) return null;
  
  return (
    <div className="mb-4">
      <div className="flex flex-wrap items-center gap-2">
        {/* Results count */}
        <span className="text-xs text-gray-500 dark:text-gray-400 mr-1">
          Showing {sortedScopes.length} of {scopes.length} items
        </span>
        
        {filters.status.map(status => (
          <span key={status} className="inline-flex items-center rounded-md bg-gray-50 dark:bg-gray-700 px-2 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 ring-1 ring-inset ring-gray-500/10 dark:ring-gray-400/30">
            Status: {status}
            <button
              type="button"
              className="ml-1 inline-flex items-center"
              onClick={() => toggleStatusFilter(status)}
            >
              <XMarkIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          </span>
        ))}
        
        {filters.budgetWarnings.map(warning => {
          const warningLabel = budgetWarningOptions.find(w => w.id === warning)?.label || warning;
          return (
            <span key={warning} className="inline-flex items-center rounded-md bg-gray-50 dark:bg-gray-700 px-2 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 ring-1 ring-inset ring-gray-500/10 dark:ring-gray-400/30">
              {warningLabel}
              <button
                type="button"
                className="ml-1 inline-flex items-center"
                onClick={() => toggleBudgetWarningFilter(warning)}
              >
                <XMarkIcon className="h-3 w-3" aria-hidden="true" />
              </button>
            </span>
          );
        })}
        
        {filters.searchText && (
          <span className="inline-flex items-center rounded-md bg-gray-50 dark:bg-gray-700 px-2 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 ring-1 ring-inset ring-gray-500/10 dark:ring-gray-400/30">
            Search: {filters.searchText}
            <button
              type="button"
              className="ml-1 inline-flex items-center"
              onClick={() => setFilters(prev => ({ ...prev, searchText: '' }))}
            >
              <XMarkIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          </span>
        )}
        
        {(filters.minBudget || filters.maxBudget) && (
          <span className="inline-flex items-center rounded-md bg-gray-50 dark:bg-gray-700 px-2 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 ring-1 ring-inset ring-gray-500/10 dark:ring-gray-400/30">
            Budget: {filters.minBudget ? `$${filters.minBudget}` : '$0'} - {filters.maxBudget ? `$${filters.maxBudget}` : '∞'}
            <button
              type="button"
              className="ml-1 inline-flex items-center"
              onClick={() => setFilters(prev => ({ ...prev, minBudget: '', maxBudget: '' }))}
            >
              <XMarkIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          </span>
        )}
        
        {(filters.minCompletion || filters.maxCompletion) && (
          <span className="inline-flex items-center rounded-md bg-gray-50 dark:bg-gray-700 px-2 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 ring-1 ring-inset ring-gray-500/10 dark:ring-gray-400/30">
            Completion: {filters.minCompletion || '0'}% - {filters.maxCompletion || '100'}%
            <button
              type="button"
              className="ml-1 inline-flex items-center"
              onClick={() => setFilters(prev => ({ ...prev, minCompletion: '', maxCompletion: '' }))}
            >
              <XMarkIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          </span>
        )}
        
        {/* Clear all filters button */}
        <button
          type="button"
          onClick={clearAllFilters}
          className="ml-2 text-xs text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300"
        >
          Clear all
        </button>
      </div>
    </div>
  );
};

export default FilterChips;